import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { openFptPortal } from '../services/fptPortal';

export default function FptPortalRedirectPage() {
  const location = useLocation();
  const [error, setError] = useState('');
  const [opening, setOpening] = useState(false);
  const open = async () => {
    setOpening(true); setError('');
    try { await openFptPortal(location.pathname.split('/')[3] || 'dashboard'); }
    catch (error) { setError(error instanceof Error ? error.message : 'Connexion au portail FPT impossible.'); }
    finally { setOpening(false); }
  };
  return <section className="mx-auto max-w-xl rounded-lg bg-white p-8 shadow">
    <h1 className="mb-3 text-xl font-bold">Votre espace FPT</h1>
    <p className="mb-6 text-gray-600">Retrouvez vos déclarations, paiements et quittances dans le Portail Assujetti FPT.</p>
    {error && <p role="alert" className="mb-4 text-red-700">{error}</p>}
    <button onClick={open} disabled={opening} className="rounded bg-purple-700 px-5 py-3 text-white disabled:opacity-50">{opening ? 'Connexion…' : 'Ouvrir mon espace FPT'}</button>
  </section>;
}
